import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import CommentsSection from "./CommentsSection";
import FeedbackSection from "./FeedbackSection";

type Props = { requestId: string };

export const ActivityBlock: React.FC<Props> = ({ requestId }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Activity</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="grid grid-cols-1 gap-6">
          <CommentsSection requestId={requestId} />
          <FeedbackSection requestId={requestId} />
        </div>
      </CardContent>
    </Card>
  );
};

export default ActivityBlock;
